import { RouteObject } from 'react-router-dom'
import { SalesPage } from './sales'
import { HourlySalesPage } from './hourly/hourly'
import { SalesDetails } from './details/details'
import { SalesLocation } from './location'
import { SalesOverview } from './overview/overview'
import { Navigate } from 'react-router-dom'
import { useEssentials } from 'hooks/utils/useEssentials'
import { isStore } from 'utils/location'

const LocationRedirectWrapper = () => {
    const { currentLocation } = useEssentials()

    if (isStore(currentLocation)) {
        return (
            <Navigate
                to={`/sales/overview?locationId=${currentLocation}`}
                replace
            />
        )
    }

    return <SalesLocation />
}
export const SalesRoute: RouteObject = {
    path: '/sales',
    element: <SalesPage />,
    children: [
        { index: true, element: <Navigate to="overview" replace /> },
        { path: 'overview', element: <SalesOverview /> },
        { path: 'details', element: <SalesDetails /> },
        { path: 'location', element: <LocationRedirectWrapper /> },
        { path: 'hourly', element: <HourlySalesPage /> },
    ],
}
